module.exports = __webpack_public_path__ + "img/47.485eb140.svg";